/**
 * Shared surface treatment for the top-level layout cards
 * (top bar, sidebar, page). Compose with `cn(...)` alongside per-card
 * layout classes (bg, flex, sizing) in each usage.
 */
export const PANEL_SURFACE = "rounded-xl border border-border shadow-sm";

/**
 * Single source of truth for the layout's responsive breakpoints.
 * - Below MOBILE: phone — sidebar overlay never shows the collapsed icon-rail.
 * - Below DESKTOP: sidebar is a fixed overlay drawer, breadcrumbs are hidden.
 * - At/above DESKTOP: sidebar sits in-flow (collapsible icon-rail), breadcrumbs show.
 */
export const MOBILE_QUERY = "(max-width: 767px)";
export const DESKTOP_QUERY = "(min-width: 1024px)";

/**
 * Horizontal inset from a top-level card's outer edge to its content:
 * PANEL_SURFACE border (1px) + the header's `p-3` padding (12px) = 13px.
 * The header's brand column subtracts this so its right divider lands exactly
 * on the sidebar's right edge below. Keep in sync if the header padding or
 * PANEL_SURFACE border change.
 */
export const CARD_CONTENT_INSET = 13;
